import { useEffect } from 'react'
import { WalletStack, WalletCard } from '../components/wallet/WalletStack'
import { Scan } from '../views/Scan/Scan'
import { Capture } from '../views/Capture/Capture'
import { Leads } from '../views/Leads/Leads'
import { Notes } from '../views/Notes/Notes'
import { EVENT } from '../constants/event'
import { useWakeLock } from '../hooks/useWakeLock'
import { ensureCurrentEvent } from '../services/events'

const CARDS: WalletCard[] = [
  {
    id: 'scan',
    title: 'Scan',
    subtitle: 'Download Nanza',
    accent: 'linear-gradient(135deg, #FF4BFF 0%, #BD0EB6 100%)',
    icon: <QrIcon />,
    affordance: 'Scan with your camera',
    render: (active) => <Scan active={active} />,
  },
  {
    id: 'capture',
    title: 'Meet',
    subtitle: 'New friends',
    accent: 'linear-gradient(135deg, #FB923C 0%, #EA580C 100%)',
    icon: <PlusIcon />,
    affordance: 'Make a new friend',
    render: () => <Capture />,
  },
  {
    id: 'leads',
    title: 'Friends',
    subtitle: 'Find your friends',
    accent: 'linear-gradient(135deg, #2E3438 0%, #101010 100%)',
    icon: <PeopleIcon />,
    affordance: 'Your friends',
    render: (active) => <Leads active={active} />,
  },
  {
    id: 'notes',
    title: EVENT.name,
    subtitle: EVENT.dateRange,
    accent: 'linear-gradient(135deg, #4E59ED 0%, #AE4EED 100%)',
    icon: <NoteIcon />,
    affordance: 'Event notes',
    render: () => <Notes />,
  },
]

function App() {
  useWakeLock()
  useEffect(() => {
    ensureCurrentEvent()
  }, [])
  return (
    <div className="min-h-screen bg-theme-background text-theme-text">
      <WalletStack cards={CARDS} defaultActiveId="scan" />
    </div>
  )
}

function QrIcon() {
  return (
    <svg viewBox="0 0 24 24" className="h-4 w-4" fill="currentColor" aria-hidden>
      <path d="M3 3h7v7H3V3zm2 2v3h3V5H5zm9-2h7v7h-7V3zm2 2v3h3V5h-3zM3 14h7v7H3v-7zm2 2v3h3v-3H5zm9-2h3v3h-3v-3zm5 0h2v2h-2v-2zm-5 5h2v2h-2v-2zm3 0h2v2h-2v-2zm2-3h2v2h-2v-2z" />
    </svg>
  )
}
function PlusIcon() {
  return (
    <svg viewBox="0 0 24 24" className="h-4 w-4" fill="none" stroke="currentColor" strokeWidth={2} strokeLinecap="round" aria-hidden>
      <path d="M12 5v14M5 12h14" />
    </svg>
  )
}
function PeopleIcon() {
  return (
    <svg viewBox="0 0 24 24" className="h-4 w-4" fill="currentColor" aria-hidden>
      <path d="M16 11c1.66 0 2.99-1.34 2.99-3S17.66 5 16 5s-3 1.34-3 3 1.34 3 3 3zm-8 0c1.66 0 2.99-1.34 2.99-3S9.66 5 8 5 5 6.34 5 8s1.34 3 3 3zm0 2c-2.33 0-7 1.17-7 3.5V19h14v-2.5c0-2.33-4.67-3.5-7-3.5zm8 0c-.29 0-.62.02-.97.05 1.16.84 1.97 1.97 1.97 3.45V19h6v-2.5c0-2.33-4.67-3.5-7-3.5z" />
    </svg>
  )
}
function NoteIcon() {
  return (
    <svg viewBox="0 0 24 24" className="h-4 w-4" fill="currentColor" aria-hidden>
      <path d="M5 3h11l3 3v15a0 0 0 0 1 0 0H5a0 0 0 0 1 0 0V3zm2 2v14h10V8h-4V5H7zm2 6h6v2H9v-2zm0 4h6v2H9v-2z" />
    </svg>
  )
}

export default App
